import { render, staticRenderFns } from "./AddressBook.vue?vue&type=template&id=8dcafb24&scoped=true"
import script from "./AddressBook.vue?vue&type=script&lang=ts"
export * from "./AddressBook.vue?vue&type=script&lang=ts"
import style0 from "./AddressBook.scss?vue&type=style&index=0&id=8dcafb24&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dcafb24",
  null
  
)

export default component.exports